var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJira(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2559 0.444458H15.2744C15.2744 2.23809 15.9869 3.95826 17.2552 5.22654C18.5235 6.49483 20.2437 7.20735 22.0373 7.20735H24.7971V9.87195C24.7995 13.6036 27.8239 16.6281 31.5555 16.6306V1.7441C31.5555 1.02653 30.9738 0.444458 30.2559 0.444458Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8431 7.90921H7.86169C7.86401 11.6408 10.8884 14.6654 14.6202 14.6678H17.38V17.341C17.3847 21.0726 20.4112 24.0951 24.1429 24.0951V9.2091C24.1429 8.49128 23.5609 7.90933 22.8431 7.90933V7.90921Z",
    fill: "url(#paint0_linear_1_5797)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.426 15.3697H0.444458C0.444458 19.1047 3.47241 22.1326 7.20734 22.1326H9.97576V24.7971C9.9782 28.5253 12.9974 31.5485 16.7257 31.5556V16.6695C16.7257 15.9516 16.1438 15.3697 15.426 15.3697Z",
    fill: "url(#paint1_linear_1_5797)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5797",
    x1: 23.8223,
    y1: 7.93527,
    x2: 17.4881,
    y2: 14.5447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_5797",
    x1: 16.834,
    y1: 15.4433,
    x2: 9.50695,
    y2: 22.6522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJira);
export default __webpack_public_path__ + "static/media/Jira.c4831a43574342cfc2242f668241f51e.svg";
export { ForwardRef as ReactComponent };